import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { formatApiErrorDetail } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("soycristianopazo@gmail.com");
  const [password, setPassword] = useState("Onboarding2026!");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  const year = new Date().getFullYear();

  return (
    <div className="min-h-screen flex">
      {/* Left brand panel con imagen de fondo */}
      <div className="hidden lg:flex flex-col justify-between lg:w-2/3 xl:w-[72%] text-white p-12 relative overflow-hidden bg-[#0B132B]"
        style={{
          backgroundImage: "url('/login-bg.webp')",
          backgroundSize: "cover",
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
        }}>
        {/* Degradado para legibilidad del texto a la izquierda */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B132B] via-[#0B132B]/85 to-transparent" />
        <div className="absolute inset-0 bg-[#0B132B]/25" />

        <div className="flex items-center relative z-10">
          <img src="/logo-sidebar.png" alt="APIFY · Onboarding de Acreditación" fetchpriority="high" decoding="async"
            className="h-16 w-auto object-contain" />
        </div>
        <div className="relative z-10 max-w-lg">
          <h1 className="font-display text-4xl font-bold leading-tight drop-shadow-lg">
            Tu próxima <span className="text-cyan-400">acreditación minera</span> comienza con el control de cada etapa.
          </h1>
          <p className="text-slate-200 mt-4 text-lg max-w-md drop-shadow">
            Centraliza el seguimiento de tus trabajadores, identifica documentos y firmas pendientes, automatiza recordatorios y acelera tus procesos de acreditación. Todo desde una sola plataforma.
          </p>
          <div className="mt-8 space-y-4 text-slate-200 max-w-md">
            {[
              { title: "Visibilidad total", desc: "Conoce el avance de acreditación de cada trabajador en tiempo real." },
              { title: "Seguimiento inteligente", desc: "Identifica pendientes, prioriza gestiones y automatiza recordatorios personalizados." },
              { title: "Control de principio a fin", desc: "Gestiona múltiples procesos de acreditación con trazabilidad y seguimiento por etapa." },
            ].map((b) => (
              <div key={b.title} className="flex items-start gap-2.5">
                <CheckCircle2 size={18} className="text-cyan-400 mt-0.5 shrink-0" />
                <div className="leading-snug">
                  <p className="font-semibold text-white">{b.title}</p>
                  <p className="text-sm text-slate-300">{b.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative z-10" />
      </div>

      {/* Right form column */}
      <div className="flex-1 flex flex-col bg-slate-50 relative">
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="w-full max-w-sm text-center">
            <h2 className="font-display text-2xl font-bold text-slate-900">Bienvenido de vuelta</h2>
            <p className="text-slate-500 mt-1 mb-8 text-sm">Ingresa a tu panel de seguimiento.</p>
            <form onSubmit={submit} className="space-y-4 text-left">
              <div>
                <label className="text-sm font-medium text-slate-700">Correo</label>
                <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                  className="mt-1 w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none text-sm" />
              </div>
              <div>
                <label className="text-sm font-medium text-slate-700">Contraseña</label>
                <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                  className="mt-1 w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none text-sm" />
              </div>
              {error && <p data-testid="login-error" className="text-sm text-red-600 text-center">{error}</p>}
              <button data-testid="login-submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60">
                {loading && <Loader2 size={16} className="animate-spin" />} Ingresar
              </button>
            </form>
            <div className="flex items-center justify-center gap-6 mt-4 text-sm">
              <Link to="/forgot-password" className="text-blue-600 hover:underline">¿Olvidaste tu contraseña?</Link>
              <Link to="/register" className="text-slate-500 hover:underline">Crear cuenta</Link>
            </div>
          </div>
        </div>
        <footer data-testid="login-footer" className="py-4 text-center text-xs text-slate-400">
          © Dosoft {year}
        </footer>
      </div>
    </div>
  );
}
